import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const LeaveRequestValidation = () => {
  const { id } = useParams();
  const [status, setStatus] = useState("En attente de validation...");
  const [error, setError] = useState(null);
  console.log(id);
  const validateLeaveRequest = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/leave-requests/validate/${id}`
      );
      if (response.data) {
        setStatus("✅ Demande de congé validée avec succès !");
      }
    } catch (err) {
      console.error(err);
      setError("Erreur lors de la validation. Réessayez.");
    }
  };

  useEffect(() => {
    console.log("dddddddddddddddddd");
    // Optionnel : appeler automatiquement à l'ouverture
    validateLeaveRequest();
  }, [id]);

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "50px",
        fontFamily: "Arial, sans-serif",
      }}>
      <h2>{status}</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default LeaveRequestValidation;
